import { useQuery } from '@tanstack/react-query';
import { hybridApi } from '../services/api';
import { format, subDays } from 'date-fns';

interface StoreWithSales {
  id: string;
  name: string;
  brand?: string;
  city?: string;
  state?: string;
  totalSales: number;
  orderCount: number;
  averageOrderValue: number;
  active: boolean;
}

export const useStoresWithSales = (date?: string, limit: number = 150) => {
  // Default to yesterday since we typically don't have today's data yet
  const targetDate = date || format(subDays(new Date(), 1), 'yyyy-MM-dd');
  
  return useQuery<StoreWithSales[]>({
    queryKey: ['stores-with-sales', targetDate, limit],
    queryFn: async () => {
      const response = await hybridApi.getStoresWithSales(targetDate, limit);

      // Handle different response formats
      // New format: { data: [...], pagination: {...} }
      if (response.data.data && Array.isArray(response.data.data)) {
        return response.data.data;
      }
      // Legacy format: { stores: [...] }
      if (response.data.stores && Array.isArray(response.data.stores)) {
        return response.data.stores;
      }
      // Direct array format
      if (Array.isArray(response.data)) {
        return response.data;
      }

      // Fallback to empty array
      console.error('Unexpected response format from getStoresWithSales:', response.data);
      return [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};